import iconAccess from '@assets/icon-account-access.svg?component';
import iconArrowLeft from '@assets/icon-arrow-left.svg?component';
import iconArrowRight from '@assets/icon-arrow-right.svg?component';
import iconArtwork from '@assets/icon-artwork.svg?component';
import iconAward from '@assets/icon-award.svg?component';
import iconBin from '@assets/icon-bin.svg?component';
import iconBook from '@assets/icon-book.svg?component';
import iconBox from '@assets/icon-box.svg?component';
import iconCall from '@assets/icon-call-chat.svg?component';
import iconCart from '@assets/icon-cart.svg?component';
import iconCheck from '@assets/icon-check.svg?component';
import iconCircleCheck from '@assets/icon-circle-check.svg?component';
import iconCloseMenu from '@assets/icon-close-menu.svg?component';
import iconEmail from '@assets/icon-email.svg?component';
import iconIdBadge from '@assets/icon-id-badge.svg?component';
import iconLeaf from '@assets/icon-leaf.svg?component';
import iconLetterBox from '@assets/icon-letter-box.svg?component';
import iconLib from '@assets/icon-library.svg?component';
import iconLock from '@assets/icon-lock.svg?component';
import iconLogout from '@assets/icon-logout.svg?component';
import iconMenu from '@assets/icon-menu.svg?component';
import iconOrdersBold from '@assets/icon-orders-bold.svg?component';
import iconPersonWaveBold from '@assets/icon-person-wave-bold.svg?component';
import iconPersonWave from '@assets/icon-person-wave.svg?component';
import iconPhone from '@assets/icon-phone.svg?component';
import iconPriceMatch from '@assets/icon-price-match.svg?component';
import iconSalesBold from '@assets/icon-sales-bold.svg?component';
import iconSearch from '@assets/icon-search.svg?component';
import iconShipping from '@assets/icon-shipping.svg?component';
import iconFacebook from '@assets/icon-social-facebook.svg?component';
import iconInstagram from '@assets/icon-social-instagram.svg?component';
import iconLinkedin from '@assets/icon-social-linkedin.svg?component';
import iconYoutube from '@assets/icon-social-youtube.svg?component';
import iconUpload from '@assets/icon-upload.svg?component';
import iconUser from '@assets/icon-user.svg?component';
import iconWhatsapp from '@assets/icon-whatsapp.svg?component';
import logo from '@assets/logo-full.svg?component';
import logoGradient from '@assets/logo-gradient.svg?component';
import logoIcon from '@assets/logo-icon.svg?component';
import logoShort from '@assets/logo-short.svg?component';
import logoWord from '@assets/logo-text.svg?component';

export const iconLibrary = {
    'icon-book': iconBook,
    'icon-logout': iconLogout,
    'icon-library': iconLib,
    'icon-id-badge': iconIdBadge,
    'icon-search': iconSearch,
    'icon-call': iconCall,
    'icon-user': iconUser,
    'icon-cart': iconCart,
    'icon-menu': iconMenu,
    'icon-leaf': iconLeaf,
    'icon-letter-box': iconLetterBox,
    'icon-facebook': iconFacebook,
    'icon-instagram': iconInstagram,
    'icon-youtube': iconYoutube,
    'icon-linkedin': iconLinkedin,
    'icon-arrow-right': iconArrowRight,
    'icon-arrow-left': iconArrowLeft,
    'logo-icon': logoIcon,
    'logo-word': logoWord,
    'logo-full': logo,
    'logo-gradient': logoGradient,
    'logo-short': logoShort,
    logo,
    'icon-shipping': iconShipping,
    'icon-box': iconBox,
    'icon-price-match': iconPriceMatch,
    'icon-person-wave': iconPersonWave,
    'icon-award': iconAward,
    'icon-close': iconCloseMenu,
    'icon-access': iconAccess,
    'icon-bin': iconBin,
    'icon-upload': iconUpload,
    'icon-circle-check': iconCircleCheck,
    'icon-check': iconCheck,
    'icon-artwork': iconArtwork,
    'icon-email': iconEmail,
    'icon-phone': iconPhone,
    'icon-whatsapp': iconWhatsapp,
    'icon-lock': iconLock,
    'icon-sales-bold': iconSalesBold,
    'icon-orders-bold': iconOrdersBold,
    'icon-person-wave-bold': iconPersonWaveBold,
} as const;

export type IconName = keyof typeof iconLibrary;

const generateIcons = () => {
    const iconObj = {} as any;

    for (const key of Object.keys(iconLibrary)) {
        const pascalKey = key
            .replace(/^icon-/, '')
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join('');

        iconObj[pascalKey] = key;
    }

    return iconObj;
};

export const Icon = generateIcons() as {
    [K in IconName as K extends `icon-${infer Rest}` ? Capitalize<Rest> : Capitalize<K>]: K;
};
